import {
  accountBudgetsUrl,
  accountHistoryUrl,
  accountingReviewReportsUrl,
  accountOverviewUrl,
  accountsAccountsUrl,
  accountsBudgetsUrl,
  accountSettingsUrl,
  accountsRequestsUrl,
  accountsUrl,
  accountsVirtualCardsUrl,
  accountTransactionsUrl,
  accountUrl,
  accountVirtualCardsUrl,
  actionUnavailableUrl,
  activityUrl,
  addExpenseUrl,
  apiKeysProfileUrl,
  apiKeysUrl,
  automationRulesUrl,
  automationSettingsUrl,
  bankAccountsUrl,
  billPayAllUrl,
  billPayDetailUrl,
  billPayNeedsApprovalUrl,
  billPayUrl,
  budgetHistoryUrl,
  budgetOverviewUrl,
  budgetsAllBudgetsUrl,
  budgetsNeedsApprovalUrl,
  budgetsRequestsUrl,
  budgetsUrl,
  budgetTransactionsUrl,
  budgetUrl,
  budgetVirtualCardsUrl,
  bulkUploadExpenseLabelsUrl,
  businessRulesUrl,
  CANCEL_SUBSCRIPTION_ROUTE,
  cardFeedDetailsUrl,
  cardFeedsUrl,
  cardsPhysicalCardsUrl,
  cardsUrl,
  changePasswordUrl,
  closeAccountUrl,
  closeBillPayCardUrl,
  closeVirtualCardUrl,
  createAutomationRuleUrl,
  createBillPayUrl,
  createBudgetUrl,
  createCardFeedUrl,
  createOrgIntegrationUrl,
  createVirtualCardUrl,
  cspSigninUrl,
  cspUserDetailUrl,
  customFieldDetailUrl,
  deactivateBudgetUrl,
  departmentDetailsUrl,
  departmentsUrl,
  downloadTransactionsUrl,
  expenseCategoriesAccountingUrl,
  expenseCategoriesAdditionalFieldsUrl,
  expenseCategoriesUrl,
  expenseCategoryLabelsUrl,
  expenseReportUrl,
  expenseRequirementsAdditionalFieldsUrl,
  expenseRequirementsReceiptRulesUrl,
  expenseRequirementsUrl,
  expensesAllReportsUrl,
  expenseSettingsUrl,
  expensesExpenseReportsUrl,
  expensesNeedsApprovalUrl,
  expensesOutOfPocketReportsUrl,
  expensesTransactionsUrl,
  expensesUrl,
  expensesYourReportsUrl,
  faqUrl,
  featureFlaggerUrl,
  helpUrl,
  homeUrl,
  insightsUrl,
  invitePeopleUrl,
  manageOrgIntegrationUrl,
  manageOrgInviteUrl,
  managerReviewReimbursementsURL,
  managerReviewReimbursementURL,
  managerReviewTransactionsURL,
  manageSubscriptionUrl,
  manageTrustedDevicesUrl,
  myWalletBudgetsPendingURL,
  myWalletBudgetsURL,
  myWalletPhysicalCardsUrl,
  myWalletReimbursementURL,
  myWalletTransactionsURL,
  myWalletUrl,
  myWalletVirtualCardDetailUrl,
  myWalletVirtualCardsUrl,
  onboardingCardUrl,
  onboardingUrl,
  organizationInfoUrl,
  organizationIntegrationsUrl,
  organizationSettingsUrl,
  organizationSsoUrl,
  orgExpenseReportsHistoricalReportsUrl,
  orgExpenseReportUrl,
  orgInviteDecisionUrl,
  orgSettingsReimbursementsUrl,
  peopleCancelOrgInviteUrl,
  peopleInvitedToOrgDetailUrl,
  peopleInvitedToOrgUrl,
  peopleMembersDetailUrl,
  peopleMembersUrl,
  peopleUrl,
  privacyUrl,
  profileDeleteUrl,
  profileInfoUrl,
  profileNotificationsUrl,
  profileOverviewUrl,
  profileSecurityUrl,
  profileUrl,
  registerAccountUrl,
  registerOrganizationUrl,
  reimbursementsUrl,
  removeUserFromOrganizationUrl,
  reportingUrl,
  requestBudgetUrl,
  requestVirtualCardUrl,
  resetPasswordUrl,
  screenVirtualCardUrl,
  searchUrl,
  setOrgExpenseReportCycleUrl,
  shareBillPayVirtualCardUrl,
  signinUrl,
  signupUrl,
  ssoCallbackUrl,
  streamingAgentUrl,
  submitExpensesUrl,
  supportRequestUrl,
  termsUrl,
  transactionAttachmentUrl,
  transactionDetailUrl,
  updateAutomationRuleUrl,
  updateBillPayUrl,
  updateBudgetRequestUrl,
  updateBudgetUrl,
  updateBulkTransactions,
  updateExpenseUrl,
  updateProfilePhotoUrl,
  updateVirtualCardUrl,
  upgradeSubscriptionUrl,
  userScreeningInfoUrl,
  verifyEmailUrl,
  virtualCardDetailUrl,
  virtualCardsAllCardsUrl,
  virtualCardsNeedsApprovalUrl,
  virtualCardsRequestsUrl,
  virtualCardsUrl,
} from 'src/navigation/urls'

// root
export const baseRouteProps = {
  path: '/',
  exact: false,
}

// authentication agnostic
export const faqRouteProps = {
  path: faqUrl(),
  exact: true,
}

export const termsRouteProps = {
  path: termsUrl(),
  exact: true,
}

export const privacyRouteProps = {
  path: privacyUrl(),
  exact: true,
}

export const supportRouteProps = {
  path: supportRequestUrl(),
  exact: true,
}

export const featureFlaggerRouteProps = {
  path: featureFlaggerUrl(),
  exact: true,
}

export const authenticationAgnosticRouteProps = {
  path: [
    faqRouteProps.path,
    termsRouteProps.path,
    privacyRouteProps.path,
    supportRouteProps.path,
    featureFlaggerRouteProps.path,
  ],
  exact: true,
}

// authed background
export const homeRouteProps = {
  path: homeUrl(),
  exact: true,
}
export const activityRouteProps = {
  path: activityUrl(),
  exact: true,
}

export const insightsRouteProps = {
  path: insightsUrl(),
  exact: true,
}

export const reportingRouteProps = {
  path: reportingUrl(),
  exact: true,
}

export const streamingAgentRouteProps = {
  path: streamingAgentUrl(),
  exact: true,
}

export const yourCardsRouteProps = {
  path: '/virtualcards',
  exact: true,
}

export const yourCardsActiveRouteProps = {
  path: '/virtualcards/active',
  exact: true,
}

export const yourCardsInactiveRouteProps = {
  path: '/virtualcards/inactive',
  exact: true,
}

export const virtualCardsRouteProps = {
  path: virtualCardsUrl(),
  exact: false,
}

export const virtualCardsAllCardsRouteProps = {
  path: virtualCardsAllCardsUrl(),
  exact: true,
}

export const virtualCardsYourCardsRouteProps = {
  path: '/virtualcards/yourcards',
  exact: true,
}

export const virtualCardsRequestsRouteProps = {
  path: virtualCardsRequestsUrl(),
  exact: true,
}

export const virtualCardsNeedsApprovalRouteProps = {
  path: virtualCardsNeedsApprovalUrl(),
  exact: true,
}

export const myWalletRouteProps = {
  path: myWalletUrl(),
  exact: false,
}

export const myWalletVirtualCardsRouteProps = {
  path: myWalletVirtualCardsUrl(),
  exact: true,
}

export const myWalletVirtualCardDetailRouteProps = {
  path: myWalletVirtualCardDetailUrl(':id'),
  exact: true,
}

export const myWalletPhysicalCardsRouteProps = {
  path: myWalletPhysicalCardsUrl(),
  exact: true,
}

export const myWalletTransactionsRouteProps = {
  path: myWalletTransactionsURL(),
  exact: true,
}

export const myWalletBudgetsRouteProps = {
  path: myWalletBudgetsURL(),
  exact: true,
}

export const cardsRouteProps = {
  path: cardsUrl(),
  exact: false,
}

export const cardsPhysicalCardsRouteProps = {
  path: cardsPhysicalCardsUrl(),
  exact: true,
}

export const expensesRouteProps = {
  path: expensesUrl(),
  exact: false,
}

export const billPayRouteProps = {
  path: billPayUrl(),
  exact: false,
}

export const billPayAllRouteProps = {
  path: billPayAllUrl(),
  exact: false,
}

export const billPayNeedsApprovalRouteProps = {
  path: billPayNeedsApprovalUrl(),
  exact: false,
}

export const onboardingRouteProps = {
  path: onboardingUrl(),
  exact: true,
}

export const onboardingCardRouteProps = {
  path: onboardingCardUrl(),
  exact: true,
}

export const orgInviteDecisionRouteProps = {
  path: orgInviteDecisionUrl(),
  exact: true,
}

export interface VirtualCardDetailMatchParams {
  id: string
}
export const virtualCardDetailRouteProps = {
  path: virtualCardDetailUrl(':id'),
  exact: true,
}

export interface BillPayDetailMatchParams {
  id: string
}
export const billPayDetailRouteProps = {
  path: billPayDetailUrl(':id'),
  exact: true,
}

export interface AccountMatchParams {
  id: string
}
export const accountRouteProps = {
  path: accountUrl(':id'),
  exact: false,
}
export interface AccountOverviewMatchParams {
  id: string
}
export const accountOverviewRouteProps = {
  path: accountOverviewUrl(':id'),
  exact: true,
}
export interface AccountBudgetsMatchParams {
  id: string
}
export const accountBudgetsRouteProps = {
  path: accountBudgetsUrl(':id'),
  exact: true,
}
export interface AccountVirtualCardsMatchParams {
  id: string
}
export const accountVirtualCardsRouteProps = {
  path: accountVirtualCardsUrl(':id'),
  exact: true,
}
export interface AccountTransactionsMatchParams {
  id: string
}
export const accountTransactionsRouteProps = {
  path: accountTransactionsUrl(':id'),
  exact: true,
}

export interface AccountBudgetHistoryMatchParams {
  id: string
}
export const accountHistoryRouteProps = {
  path: accountHistoryUrl(':id'),
  exact: true,
}
export interface AccountSettingsMatchParams {
  id: string
}
export const accountSettingsRouteProps = {
  path: accountSettingsUrl(':id'),
  exact: true,
}

export const accountsRouteProps = {
  path: accountsUrl(),
  exact: false,
}
export const accountsAccountsRouteProps = {
  path: accountsAccountsUrl(),
  exact: true,
}
export const accountsBudgetsRouteProps = {
  path: accountsBudgetsUrl(),
  exact: true,
}

export const accountsVirtualCardsRouteProps = {
  path: accountsVirtualCardsUrl(),
  exact: true,
}
export const accountsRequestsRouteProps = {
  path: accountsRequestsUrl(),
  exact: true,
}

export const closeAccountRouteProps = {
  path: closeAccountUrl(':id'),
  exact: true,
}

export interface CloseAccountCardContentRouteProps {
  id: string
}
export const closeAccountContentRouteProps = {
  path: closeAccountUrl(':id'),
  exact: true,
}

export const budgetsRouteProps = {
  path: budgetsUrl(),
  exact: false,
}

export const myWalletBudgetsPendingRouteProps = {
  path: myWalletBudgetsPendingURL(),
  exact: true,
}

export const budgetsAllBudgetsRouteProps = {
  path: budgetsAllBudgetsUrl(),
  exact: true,
}

export const budgetsRequestsRouteProps = {
  path: budgetsRequestsUrl(),
  exact: true,
}

export const budgetsNeedsApprovalRouteProps = {
  path: budgetsNeedsApprovalUrl(),
  exact: true,
}
export interface BudgetMatchParams {
  id: string
}
export const budgetRouteProps = {
  path: budgetUrl(':id'),
  exact: false,
}
export interface BudgetOverviewMatchParams {
  id: string
}
export const budgetOverviewRouteProps = {
  path: budgetOverviewUrl(':id'),
  exact: true,
}
export interface BudgetVirtualCardsMatchParams {
  id: string
}
export const budgetVirtualCardsRouteProps = {
  path: budgetVirtualCardsUrl(':id'),
  exact: true,
}
export interface BudgetTransactionsMatchParams {
  id: string
}
export const budgetTransactionsRouteProps = {
  path: budgetTransactionsUrl(':id'),
  exact: true,
}

export interface BudgetBudgetHistoryMatchParams {
  id: string
}
export const budgetHistoryRouteProps = {
  path: budgetHistoryUrl(':id'),
  exact: true,
}

export const profileRouteProps = {
  path: profileUrl(),
  exact: false,
}
export const profileOverviewRouteProps = {
  path: profileOverviewUrl(),
  exact: true,
}
export const profileInfoRouteProps = {
  path: profileInfoUrl(),
  exact: true,
}
export const profileNotificationsRouteProps = {
  path: profileNotificationsUrl(),
  exact: true,
}
export const profileDeleteRouteProps = {
  path: profileDeleteUrl(),
  exact: true,
}
export const profileSecurityRouteProps = {
  path: profileSecurityUrl(),
  exact: true,
}
export const peopleRouteProps = {
  path: peopleUrl(),
  exact: false,
}
export const invitePeopleRouteProps = {
  path: invitePeopleUrl(),
  exact: false,
}
export const expensesAllReportsRouteProps = {
  path: expensesAllReportsUrl(),
  exact: true,
}
export const expensesYourReportsRouteProps = {
  path: expensesYourReportsUrl(),
  exact: true,
}
export const expensesOutOfPocketReportsRouteProps = {
  path: expensesOutOfPocketReportsUrl(),
  exact: true,
}
export const expensesOutOfPocketReportsAllRouteProps = {
  path: reimbursementsUrl(),
  exact: true,
}
export const expensesOutOfPocketReportsYoursRouteProps = {
  path: submitExpensesUrl(),
  exact: true,
}
export const managerReviewReimbursementsRouteProps = {
  path: managerReviewReimbursementsURL(),
  exact: true,
}
export const managerReviewTransactionsRouteProps = {
  path: managerReviewTransactionsURL(),
  exact: true,
}
export const expensesTransactionsRouteProps = {
  path: expensesTransactionsUrl(),
  exact: true,
}
export const expensesNeedsApprovalRouteProps = {
  path: expensesNeedsApprovalUrl(),
  exact: true,
}
export const expensesExpenseReportsRouteProps = {
  path: expensesExpenseReportsUrl(),
  exact: true,
}

export interface ExpenseReportMatchParams {
  id: string
}
export const expenseReportRouteProps = {
  path: expenseReportUrl(':id'),
  exact: true,
}
export const myWalletReimbursementRouteProps = {
  path: myWalletReimbursementURL(':id'),
  exact: true,
}

export const managerReviewReimbursementRouteProps = {
  path: managerReviewReimbursementURL(':id'),
  exact: true,
}

export interface PeopleMembersDetailMatchParams {
  id: string
}
export const peopleMembersDetailRouteProps = {
  path: peopleMembersDetailUrl(':id'),
  exact: true,
}

export interface PeopleInvitedToOrgDetailMatchParams {
  id: string
}
export const peopleInvitedToOrgDetailRouteProps = {
  path: peopleInvitedToOrgDetailUrl(':id'),
  exact: true,
}

export const peopleMembersRouteProps = {
  path: peopleMembersUrl(),
  exact: true,
}

export const peopleInvitedToOrgRouteProps = {
  path: peopleInvitedToOrgUrl(),
  exact: true,
}

export interface PeopleCancelOrgInviteMatchParams {
  id: string
}
export const peopleCancelOrgInviteRouteProps = {
  path: peopleCancelOrgInviteUrl(':id'),
  exact: true,
}

export interface ScreenVirtualCardMatchParams {
  id: string
}
export const screenVirtualCardRouteProps = {
  path: screenVirtualCardUrl(':id'),
  exact: true,
}

export interface DeactivateBudgetMatchParams {
  id: string
}
export const deactivateBudgetRouteProps = {
  path: deactivateBudgetUrl(':id'),
  exact: true,
}

export const registerAccountRouteProps = {
  path: registerAccountUrl(),
  exact: true,
}

export const updateProfilePhotoRouteProps = {
  path: updateProfilePhotoUrl(),
  exact: true,
}

export const upgradeSubscriptionRouteProps = {
  path: upgradeSubscriptionUrl(),
  exact: true,
}

export const userScreeningInfoRouteProps = {
  path: userScreeningInfoUrl(),
  exact: true,
}

export interface CreateOrgIntegrationMatchParams {
  id: string
}
export const createOrgIntegrationRouteProps = {
  path: createOrgIntegrationUrl(':id'),
  exact: true,
}

export interface ManageOrgIntegrationMatchParams {
  id: string
  integrationId: string
}
export const manageOrgIntegrationRouteProps = {
  path: manageOrgIntegrationUrl(':id', ':integrationId'),
  exact: true,
}

export const actionUnavailableRouteProps = {
  path: actionUnavailableUrl(),
  exact: true,
}

export const downloadTransactionsRouteProps = {
  path: downloadTransactionsUrl(),
  exact: true,
}

export const registerOrganizationRouteProps = {
  path: registerOrganizationUrl(),
  exact: true,
}
export interface ManageOrgInviteMatchParams {
  id: string
}
export const manageOrgInviteRouteProps = {
  path: manageOrgInviteUrl(':id'),
  exact: true,
}
export interface RemoveUserFromOrganizationMatchParams {
  id: string
}
export const removeUserFromOrganizationRouteProps = {
  path: removeUserFromOrganizationUrl(':id'),
  exact: true,
}

export interface OrgIntegrationsMatchParams {
  id: string
}
export const orgIntegrationsRouteProps = {
  path: organizationIntegrationsUrl(':id'),
  exact: true,
}

export interface CloseVirtualCardMatchParams {
  id: string
}
export const closeVirtualCardRouteProps = {
  path: closeVirtualCardUrl(':id'),
  exact: true,
}

export interface CloseBillPayCardMatchParams {
  id: string
}
export const closeBillPayCardRouteProps = {
  path: closeBillPayCardUrl(':id'),
  exact: true,
}

export interface CloseVirtualCardCardContentRouteProps {
  id: string
}
export const closeVirtualCardContentRouteProps = {
  path: [closeBillPayCardUrl(':id'), closeVirtualCardUrl(':id')],
  exact: true,
}

export interface ShareBillPayVirtualCardMatchParams {
  id: string
}
export const shareBillPayVirtualCardRouteProps = {
  path: shareBillPayVirtualCardUrl(':id'),
  exact: true,
}

// authed left flyout
export const helpRouteProps = {
  path: helpUrl(),
  exact: true,
}
export const searchRouteProps = {
  path: searchUrl(),
  exact: true,
}
export interface CspUserDetailMatchParams {
  id: string
}
export const cspUserDetailRouteProps = {
  path: cspUserDetailUrl(':id'),
  exact: true,
}

// authed right flyout
export const createVirtualCardRouteProps = {
  path: createVirtualCardUrl(),
  exact: true,
}

export const requestVirtualCardRouteProps = {
  path: requestVirtualCardUrl(),
  exact: true,
}

export interface UpdateVirtualCardMatchParams {
  id: string
}
export const updateVirtualCardRouteProps = {
  path: updateVirtualCardUrl(':id'),
  exact: true,
}

export interface UpdateBillPayMatchParams {
  id: string
}
export const updateBillPayRouteProps = {
  path: updateBillPayUrl(':id'),
  exact: true,
}

export interface UpdateVirtualCardFormRouteProps {
  id: string
}
export const updateVirtualCardFormRouteProps = {
  path: [updateVirtualCardUrl(':id'), updateBillPayUrl(':id')],
  exact: true,
}

export const createBudgetRouteProps = {
  path: createBudgetUrl(),
  exact: true,
}

export const requestBudgetRouteProps = {
  path: requestBudgetUrl(),
  exact: true,
}

export interface UpdateBudgetRequestMatchParams {
  id: string
}

export const updateBudgetRequestRouteProps = {
  path: updateBudgetRequestUrl(':id'),
  exact: true,
}

export interface UpdateBudgetMatchParams {
  id: string
}
export const updateBudgetRouteProps = {
  path: updateBudgetUrl(':id'),
  exact: true,
}

export interface TransactionDetailMatchParams {
  id: string
  attachmentId?: string
}
export const transactionDetailRouteProps = {
  path: [
    transactionDetailUrl(':id'),
    transactionAttachmentUrl(':id', ':attachmentId'),
  ],
  exact: true,
}

export interface AddExpenseMatchParams {
  id: string
}
export const addExpenseRouteProps = {
  path: addExpenseUrl(':id'),
  exact: true,
}

export interface UpdateExpenseMatchParams {
  id: string
}
export const updateExpenseRouteProps = {
  path: updateExpenseUrl(':id'),
  exact: true,
}

export const updateBulkTransactionsRouteProps = {
  path: updateBulkTransactions(),
  exact: true,
}

export interface CreateAutomationRuleMatchParams {
  id: string
}
export const createAutomationRuleRouteProps = {
  path: createAutomationRuleUrl(':id'),
  exact: true,
}

export interface UpdateAutomationRuleMatchParams {
  orgId: string
  ruleId: string
}
export const updateAutomationRuleRouteProps = {
  path: updateAutomationRuleUrl(':orgId', ':ruleId'),
  exact: true,
}

export const bulkUploadExpenseLabelsRouteProps = {
  path: bulkUploadExpenseLabelsUrl(':orgId', ':expenseCategoryId'),
  exact: true,
}

// unauthed
export const signinRouteProps = {
  path: signinUrl(),
  exact: true,
}

export const signupRouteProps = {
  path: signupUrl(),
  exact: true,
}

export const verifyEmailRouteProps = {
  path: verifyEmailUrl(),
  exact: true,
}

export const resetPasswordRouteProps = {
  path: resetPasswordUrl(),
  exact: true,
}

export const cspSigninRouteProps = {
  path: cspSigninUrl(),
  exact: true,
}

export const changePasswordRouteProps = {
  path: changePasswordUrl(),
  exact: true,
}

export const ssoCallbackRouteProps = {
  path: ssoCallbackUrl(),
  exact: true,
}

export const cancelSubscriptionRouteProps = {
  path: CANCEL_SUBSCRIPTION_ROUTE(':id'),
  exact: true,
}

export interface CancelSubscriptionMatchParams {
  id: string
}

export const manageTrustedDevicesRouteProps = {
  path: manageTrustedDevicesUrl(),
  exact: true,
}

export interface OrganizationsMatchParams {
  id: string
}

export const organizationSettingsRouteProps = {
  path: organizationSettingsUrl(':id'),
  exact: false,
}

export const organizationSSOSettingsRouteProps = {
  path: organizationSsoUrl(':id'),
  exact: true,
}

export const automationSettingsRouteProps = {
  path: automationSettingsUrl(':id'),
  exact: false,
}

export const businessRulesRouteProps = {
  path: businessRulesUrl(':id'),
  exact: true,
}

export const orgSettingsReimbursementsRouteProps = {
  path: orgSettingsReimbursementsUrl(':id'),
  exact: true,
}

export const apiKeysRouteProps = {
  path: apiKeysUrl(':id'),
}

export const apiKeysProfileRouteProps = {
  path: apiKeysProfileUrl(),
}

export const organizationInfoRouteProps = {
  path: organizationInfoUrl(':id'),
  exact: true,
}

export const bankAccountsRouteProps = {
  path: bankAccountsUrl(':id'),
  exact: true,
}

export const manageSubscriptionRouteProps = {
  path: manageSubscriptionUrl(':id'),
  exact: true,
}

export interface ExpenseCategoriesMatchParams {
  id: string
}

export const expenseCategoriesRouteProps = {
  path: expenseCategoriesUrl(':id'),
  exact: false,
}

export const expenseCategoriesAccountingRouteProps = {
  path: [expenseCategoriesUrl(':id'), expenseCategoriesAccountingUrl(':id')],
  exact: true,
}

export const expenseCategoriesAdditionalFieldsRouteProps = {
  path: expenseCategoriesAdditionalFieldsUrl(':id'),
  exact: true,
}

export interface CustomFieldDetailMatchParams {
  orgId: string
  customFieldId: string
}

export const customFieldDetailRouteProps = {
  path: customFieldDetailUrl(':orgId', ':customFieldId'),
  exact: true,
}

export interface AutomationRulesMatchParams {
  id: string
}

export const automationRulesRouteProps = {
  path: automationRulesUrl(':id'),
  exact: true,
}

export interface ExpenseCategoryLabelsMatchParams {
  orgId: string
  expenseCategoryId: string
}

export const expenseCategoryLabelsRouteProps = {
  path: expenseCategoryLabelsUrl(':orgId', ':expenseCategoryId'),
  exact: true,
}

export interface ExpenseSettingsMatchParams {
  id: string
}

export const expenseSettingsRouteProps = {
  path: expenseSettingsUrl(':id'),
  exact: true,
}

export interface DepartmentsMatchParams {
  id: string
}

export const departmentsRouteProps = {
  path: departmentsUrl(':id'),
  exact: true,
}

export const cardFeedsRouteProps = {
  path: cardFeedsUrl(),
  exact: true,
}

export interface CardFeedDetailsMatchParams {
  id: string
}

export const cardFeedDetailsRouteProps = {
  path: cardFeedDetailsUrl(':id'),
  exact: true,
}

export const createCardFeedRouteProps = {
  path: createCardFeedUrl(),
  exact: true,
}

export interface DepartmentDetailsMatchParams {
  orgId: string
  departmentId: string
}

export const departmentDetailsRouteProps = {
  path: departmentDetailsUrl(':orgId', ':departmentId'),
  exact: true,
}

export interface OrgExpenseReportsHistoricalReportsMatchParams {
  id: string
}

export const orgExpenseReportsHistoricalReportsRouteProps = {
  path: orgExpenseReportsHistoricalReportsUrl(':id'),
  exact: true,
}

export interface OrgExpenseReportMatchParams {
  cycleId: string
  reportId: string
}

export const orgExpenseReportRouteProps = {
  path: orgExpenseReportUrl(':cycleId', ':reportId'),
  exact: true,
}

export interface SetOrgExpenseReportCycleMatchParams {
  id: string
}

export const setOrgExpenseReportCycleRouteProps = {
  path: setOrgExpenseReportCycleUrl(':id'),
  exact: true,
}

export const createBillPayRouteProps = {
  path: createBillPayUrl(),
  exact: true,
}

export const accountingReviewReportsRouteProps = {
  path: accountingReviewReportsUrl(),
  exact: true,
}

export interface ExpenseRequirementsMatchParams {
  id: string
}

export const expenseRequirementsRouteProps = {
  path: expenseRequirementsUrl(':id'),
  exact: false,
}

export const expenseRequirementsReceiptRulesRouteProps = {
  path: expenseRequirementsReceiptRulesUrl(':id'),
  exact: true,
}

export const expenseRequirementsAdditionalFieldsRouteProps = {
  path: expenseRequirementsAdditionalFieldsUrl(':id'),
  exact: true,
}
